import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Toolbar, Tooltip, IconButton, Typography } from '@mui/material';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
import { TextField } from '@totalsoft/rocket-ui';

const EngineScoringTestHeaderComponent = ({ onFilterValueChanged, fullTextFilter, onRefresh, scoringTestScore }) => {
  const { t } = useTranslation();

  const onTextFilterChanged = () => event => {
    const value = event;
    onFilterValueChanged(value, true);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={3}>
        <Typography variant='h6' component='h4' sx={{ mt: 2 }}>
          {t('EngineScoring.Test.Score')}: {scoringTestScore || 0}
        </Typography>
      </Grid>
      <Grid item xs={3}></Grid>
      <Grid item xs={6}>
        <Toolbar>
          <TextField
            fullWidth={true}
            name='fullTextFilter'
            value={fullTextFilter}
            onChange={onTextFilterChanged('fullTextFilter')}
            placeholder={t('EngineScoring.Test.Search')}
            startAdornment={<Search />}
            endAdornment={
              <Tooltip title={t('Tooltips.ResetFilters')}>
                <IconButton onClick={onRefresh}>
                  <Close />
                </IconButton>
              </Tooltip>
            }
          />
        </Toolbar>
      </Grid>
    </Grid>
  );
};

EngineScoringTestHeaderComponent.propTypes = {
  onFilterValueChanged: PropTypes.func.isRequired,
  fullTextFilter: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
  scoringTestScore: PropTypes.number
};

export default EngineScoringTestHeaderComponent;
